import React, {useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import * as Yup from "yup";
import {ErrorMessage, useForm} from "react-hook-form";

import {FORM, MAX_NAME, REQUIRED,} from "../../../components/i18n/i18n";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {showLoader} from "../../../components/loader/loader";
import {MAX_NAME_SIZE} from "../../../components/menu-flower/constants";
import {phoneCodeService} from "../../../jwt/_services/hotel/phoneCodeService";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";


const PhoneCodeForm = props => {
    const [fbDataBaseId] = useState(props?.app?.fbDataBase?.id);
    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME),
        name: Yup.string().required(REQUIRED),
        iso: Yup.string().required(REQUIRED),
        iso2: Yup.string().required(REQUIRED),
        idCode: Yup.number().required(REQUIRED),
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: savedData?.id,
            name: savedData?.name,
            code: savedData?.code,
            iso: savedData?.iso,
            iso2: savedData?.iso2,
            idCode: savedData?.idCode,
        }
    });

    const onSubmit = (data, _) => {
        setLoading(true);
        const dataRequest = {
            fbDataBase:  { id : fbDataBaseId },
            item:{
                id: data.id,
                idCode: data.idCode,
                code: data.code,
                name: data.name,
                iso: data.iso,
                iso2: data.iso2,
            }
        };

        if (!editMode) {
            //Save
            return phoneCodeService.saveItem(dataRequest)
                .then(resultData => setResult(resultData))
                .finally(() => setLoading(false))
        } else {
            //Update
            let id = savedData.id;
            dataRequest.item.id = savedData?.id

            return phoneCodeService.updateItem(id, dataRequest)
                .then(resultData => setResult(resultData))
                .finally(() => setLoading(false))
        }
    };

    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true)
    }

    const resetForm = () => {
        setSavedData(null);
        setEditMode(false);
        setDisableInputs(false);
        setSaveSuccess(false);
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
    }

    const setForm = () => props.setForm();

    return (
        <Card>
            {loading && showLoader()}
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="id">ID</Label>
                                <Input type="id" name="id" id="id"
                                       disabled
                                       value={editMode ? savedData?.id : ''}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>Nombre</Label>
                                <Input type="text" name="name"
                                       placeholder="Ingrese nombre"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.name ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="name" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>Id</Label>
                                <br/>
                                <Input type="number" name="idCode"
                                       placeholder="Ingrese id"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.idCode ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="idCode" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>Codigo</Label>
                                <Input type="text" name="code"
                                       placeholder="Ingrese código"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.code ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="code" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>ISO</Label>
                                <Input type="text" name="iso"
                                       placeholder="Ingrese ISO"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.iso ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="iso" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>ISO (2 char)</Label>
                                <Input type="text" name="iso2"
                                       placeholder="Ingrese ISO (2 char)"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.iso2 ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="iso2" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                    </Row>

                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={() => { resetForm() }}/>
                                    <ButtonEdit onClick={() => {  beginEdit() }}/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
}

export default PhoneCodeForm